export const generator = {
  formButtonGetFreeQuote: 'Kostenlos Offerten anfordern',
  formButtonGetFreeQuoteSmall: 'Senden',
}
